// extracted by mini-css-extract-plugin
export default {"dlGridFilterLabel":"src-js-common-components-filters-GridFilterLabel---dlGridFilterLabel---vb3+i"};